/**
 * Which VoiceAgent a build job is building, remembered between the wizard and Building.
 *
 * The prototype's Building screen is headed with the agent's name and template ("Roma orders ·
 * Delivery & ordering", "Tailoring Roma orders to your business."). The build stream only
 * names the VoiceAgent in its final `build.succeeded` frame, and the route carries nothing but
 * the build job id. The wizard, however, has just been told both ids by `createVoiceAgent`,
 * so it leaves the VoiceAgent id in the query cache under the build job's key and Building
 * reads the agent itself from there — real data, through the ordinary `getVoiceAgent` read.
 *
 * Nothing is invented when the cache is cold (a reload, or a link someone was sent): Building
 * then speaks of "your agent" until `build.succeeded` names it.
 */
import type { QueryClient } from "@tanstack/react-query";

const buildOriginKey = (buildJobId: string) => ["build-origin", buildJobId] as const;

export function rememberBuildOrigin(
  client: QueryClient,
  buildJobId: string,
  voiceAgentId: string,
): void {
  client.setQueryData(buildOriginKey(buildJobId), voiceAgentId);
}

export function recallBuildOrigin(client: QueryClient, buildJobId: string): string | null {
  const known = client.getQueryData<string>(buildOriginKey(buildJobId));
  return known === undefined ? null : known;
}
